export const DocumentTypeEnum = {
  ExportItems: 11,
  UniversalDataExport: 12,
  ImportedLAPApplicationsReport: 14,
  ImportedDCApplicationsReport: 15,
  CNUpdateResultsReport: 16,
  CNUpdatePreviewReport: 17,
  RemoveReplaceIngredientReport: 18,
};

export const ExportFileNameEnum = {
  ExportItems: 'ItemExport_',
  UniversalDataExport: 'UniversalDataExport_',
  ImportedLAPApplicationsReport: 'ImportedLAPApplications',
  ImportedDCApplicationsReport: 'ImportedDCApplications',
  CNUpdateResultsReport: 'CNUpdateResultsReport',
  CNUpdatePreviewReport: 'CNUpdatePreviewReport',
  RemoveReplaceIngredientReport: 'Remove/ReplaceIngredientResults_',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ProcessedDocumentsEnum.js